/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { computed, Signal } from '@angular/core';
import { signalStore, withState, withMethods, patchState, getState } from '@ngrx/signals';
import { SelectItemsVoModel } from '@well/common-libs/select-items/domain';

interface SelectItemsState {
  selectItems: Record<string, SelectItemsVoModel[]>;
}

const initialState: SelectItemsState = {
  selectItems: {},
};

export const SelectItemsStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withMethods((store) => ({
    setSelectItems(locale: string, items: SelectItemsVoModel[]): void {
      const currentItems = getState(store).selectItems;
      patchState(store, {
        selectItems: { ...currentItems, [locale]: items },
      });
    },

    getSelectItemByKey(locale: string, key: string): Signal<SelectItemsVoModel | undefined> {
      return computed(() => {
        const items = store.selectItems()[locale];
        return items?.find((i) => i.key === key);
      });
    },

    getSelectItemsByFieldName(locale: string, fieldName: string): Signal<SelectItemsVoModel[]> {
      return computed(() => {
        const items = store.selectItems()[locale];
        return items?.filter((i) => i.fieldName === fieldName) ?? [];
      });
    },
  }))
);
